import { render, staticRenderFns } from "./WaitingRoom.vue?vue&type=template&id=43758932&"
import script from "./WaitingRoom.vue?vue&type=script&lang=ts&"
export * from "./WaitingRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports